'use client';

import { motion, useScroll, useTransform } from 'framer-motion';
import { useState } from 'react';

import { IconButton } from '@/components/atoms/iconButton';

import IconClose from '~/svg/IconCross.svg';
import { Text } from '@/components/atoms/text';

export type PopupBannerProps = {
  image: React.ReactNode;
  title: string;
  description: React.ReactNode;
  cta?: React.ReactNode;
};

export const PopupBanner = ({
  image,
  title,
  description,
  cta,
}: PopupBannerProps) => {
  const [isVisible, setIsVisible] = useState(true);

  const { scrollY } = useScroll();

  const opacity = useTransform(scrollY, [200, 480], [0, 1]);
  const y = useTransform(scrollY, [240, 440], ['100%', '0%']);

  return (
    <motion.div
      style={{ opacity, y, visibility: isVisible ? 'visible' : 'hidden' }}
      aria-hidden={!isVisible}
      className='bg-neutral-N00 shadow-popup fixed bottom-6 left-6 z-[100] hidden min-w-[320px] max-w-[600px] items-center gap-6 rounded-xl p-6 md:flex'
    >
      <div className='flex flex-col gap-y-3'>
        <div className='flex gap-x-3'>
          {image}
          <Text variant='subtitle-l'>{title}</Text>
        </div>
        {description}
      </div>
      {cta}
      <IconButton
        variant='text'
        classNames={{
          root: 'absolute top-2 right-2 p-0 h-6 w-6',
          inner: 'text-neutral-N20 hover:text-neutral-N99',
        }}
        size='s'
        color='secondary'
        slim
        onClick={() => setIsVisible(!isVisible)}
      >
        <IconClose />
      </IconButton>
    </motion.div>
  );
};
